import app from 'flarum/forum/app';
import ModerationFlagsPage from './components/ModerationFlagsPage';
app.initializers.add('bhic-flags-moderation', () => {
  // flarum/flags registers the 'flags' route with its own (minimal) FlagsPage
  // before this runs: site JS loads after extension JS. Swap in the richer
  // moderation page; the header dropdown keeps the compact stock list. If the
  // flags extension is disabled there is no route (and no moderation to do).
  if (app.routes.flags) {
    app.routes.flags.component = ModerationFlagsPage;
  }
});